import { defineMessages } from 'react-intl';

/** The AI assistants card on the artist Home (design: ai-assistants n1-n4). */
export const aiNudgeMessages = defineMessages({
  title: { id: 'app.sml.home.aiNudge.title', defaultMessage: 'Run your release from Claude or ChatGPT' },
  body: {
    id: 'app.sml.home.aiNudge.body',
    defaultMessage: 'Ask for reels, a post plan or what moved this week. Your assistant does it in MUSIC24.',
  },
  cta: { id: 'app.sml.home.aiNudge.cta', defaultMessage: 'Set it up' },
  dismiss: { id: 'app.sml.home.aiNudge.dismiss', defaultMessage: 'Hide this card' },
});
